import React from "react";
import { MapPinned, Star, X } from "lucide-react";

function renderStars(value) {
  const full = Math.floor(value);
  const half = value % 1 >= 0.5 ? 1 : 0;
  const empty = 5 - full - half;
  return "★".repeat(full) + (half ? "☆" : "") + "☆".repeat(empty);
}

export default function InfoPopupRatingsActionsSection({ infoPopup }) {
  const {
    t,
    data,
    hideRating,
    locationStats,
    hideLocationButton,
    isPrivateLocation,
    openMapAtLocation,
    onClose,
  } = infoPopup;

  const hasPostRating = !hideRating && data.rating > 0;
  const hasLocationRating = Boolean(locationStats);
  const canGoToLocation =
    !hideLocationButton && !isPrivateLocation && Boolean(data.coordinates);

  const renderRatingRow = (Icon, label, value) => (
    <div className="info-popup-stacked-row">
      <span className="info-popup-stacked-row-icon" aria-hidden="true">
        <Icon size={16} strokeWidth={2.25} />
      </span>
      <span className="info-popup-stacked-row-copy">
        <span className="info-popup-stacked-row-label">{label}</span>
        <strong>{value}</strong>
      </span>
    </div>
  );

  return (
    <>
      {(hasPostRating || hasLocationRating) && (
        <section className="info-popup-section info-popup-section--ratings">
          <h4 className="info-popup-section-title">
            {t("info_popup_section_ratings")}
          </h4>
          <div className="info-popup-stacked-card">
            {hasPostRating &&
              renderRatingRow(
                Star,
                t("post_rating"),
                <span className="info-popup-stars">
                  {"★".repeat(data.rating)}
                </span>
              )}

            {hasLocationRating &&
              renderRatingRow(
                MapPinned,
                t("location_average"),
                <>
                  <span className="stars">
                    {renderStars(locationStats.avg)}
                  </span>
                  &nbsp;
                  <span>{locationStats.avg.toFixed(1)} / 5</span>
                  &nbsp;
                  <span className="meta">
                    ({t("from")} {locationStats.count}{" "}
                    {locationStats.count === 1 ? t("post") : t("posts")})
                  </span>
                </>
              )}
          </div>
        </section>
      )}

      <div className="info-popup-bottom-actions">
        {canGoToLocation && (
          <button
            type="button"
            onClick={openMapAtLocation}
            className="info-popup-action-btn info-popup-action-btn--primary"
          >
            <MapPinned size={16} strokeWidth={2.25} aria-hidden="true" />
            <span>{t("go_to_location")}</span>
          </button>
        )}

        <button
          type="button"
          onClick={onClose}
          className="info-popup-action-btn info-popup-action-btn--secondary"
        >
          <X size={16} strokeWidth={2.25} aria-hidden="true" />
          <span>{t("close")}</span>
        </button>
      </div>
    </>
  );
}
